import { createFileRoute } from '@tanstack/react-router';

import MetadataForm from '@@containers/metadata/MetadataForm';
import { teaserModalSearchParams } from '@@containers/Teaser/teaserModalSearchParams';

export const Route = createFileRoute('/_authenticated/tickers/$id/metadata')({
    validateSearch: teaserModalSearchParams,
    component: MetadataForm,
});
